export default {
  title: 'Nous sommes désolés...',
  description: "Votre session a expiré pour cause d'inactivité.",
  goBack: "Veuillez retourner à la page d'accueil pour recommencer votre application",
  startOver: "Retour à la page d'accueil",
  titleNoReturn: 'Votre lien a expiré',
  descriptionNoReturn: 'Nous devrons envoyer un nouveau lien.',
};
